<template>
    <div class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '日均助贷余额表'}]"/>
        <el-row class="xzpadd10 bg-purple">
            <data-table
                :tableData="tableData"
                :columns="columns"
                :pageSize.sync="pageSize"
                :page.sync="page"
                :filters="filters"
                :actions="actions"
            ></data-table>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "OutstandingMonthly2021List",
        data(){
            return{
                columns:[
                    {
                        name: '序号',
                        type: 'index'
                    },
                    {
                        label: '统计年月',
                        field: 't__asOf'
                    },
                    {
                        label: '贷款笔数',
                        field: 't__counts'
                    },
                    {
                        label: '日均贷款余额',
                        field: 't__outstandingAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '明细',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'OutstandingDaily2021',
                                            query: {
                                                asOf: row.t__asOf
                                            }
                                        }
                                    )
                                }
                            },
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                dealerTypeOptions:[],
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '刷新数据',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.UpdateData()
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        dt__deviceType:'',
                    },
                    columns: [
                        {
                            label: '统计年份',
                            component: 'date-range-picker',
                            field: 't__asOf',
                            op: ['gteq', 'lteq'],
                            span:12,
                            type: 'year',
                            valueFormat: [
                                'yyyy-01-01 00:00:00',
                                'yyyy-12-31 23:59:59',
                            ]
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()

        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getOutstandingMonthly2021(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            UpdateData: function () {
                xhr.updateOutstandingMonthly2021({
                    'month':'',
                }, res=> {
                    try {
                        if (res.data.status == 'success') {
                            this.getData()
                        }
                    } catch (e) {
                    }
                })

            }


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/OutstandingMonthly2021List.vue